// extracted by mini-css-extract-plugin
module.exports = {"quote":"style-module--quote--22KEX","author":"style-module--author--1Se_Z","container":"style-module--container--e1uBw"};